import { render, staticRenderFns } from "./ContPrograms.vue?vue&type=template&id=45fdac3c&"
import script from "./ContPrograms.vue?vue&type=script&lang=js&"
export * from "./ContPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports